export const frontmatter = {
    "title": "Glosario de términos",
    "description": "Definición oficial de todos los términos técnicos y de negocio usados en la plataforma OnnIA.",
    "sidebar_label": "Glosario",
    "sidebar_group": "referencia",
    "sidebar_order": 1
}

export const toc = []